import React, { useEffect, useState } from "react";
import { BreakdownWrapper } from "./styles";
import {
  StyledParagraph,
  StyledTitle,
} from "../CustomAntdComponents/Typography";
import { formatNumberAsCurrency } from "../../utils/helpers";
import { SpaceBetweenAlignContent } from "../CustomAntdComponents/Utitlities";
import { useBookingStore } from "../../store/booking/bookingStore";
import { useRoadSearchStore } from "../../store/roadSearch/roadSearchStore";
import {
  calculateRoadFareBreakdown,
  calculateTotalFare,
} from "../AvailableBuses/helper";
import {
  calculateTicketTotal,
  calculateTicketTotalDiscountPrice,
  calculateTicketTotalOldPrice,
} from "../AvailableFlights/helper";
import { StrikeThroughAmount } from "../AvailableFlights/styles";
import translations from "../../screens/PassengerDetails/translations";
import { useI18nContext } from "../../utils/I18n";

type Props = {
  hideBreakdown: boolean;
};
const RoadFareBreakdown = ({ hideBreakdown }: Props) => {
  const {
    formData: { numberOfAdults },
    selectedBus,
  } = useRoadSearchStore();
  const {
    state: { t },
  } = useI18nContext();

  const { bookingPayload, confirmData } = useBookingStore();

  const { totalAmount } = calculateTotalFare(selectedBus, numberOfAdults);
  const paxFares = calculateRoadFareBreakdown(selectedBus);
  const bookingAmount = bookingPayload
    ? calculateTicketTotal(bookingPayload.TicketingDetails)
    : totalAmount;
  const isRoundTripFares = paxFares.length > 1;

  const discountAmount = confirmData
    ? calculateTicketTotalDiscountPrice(confirmData)
    : 0;

  const totalOldPrice = confirmData
    ? calculateTicketTotalOldPrice(confirmData)
    : 0;

  return (
    <div>
      {!hideBreakdown && (
        <BreakdownWrapper>
          {isRoundTripFares
            ? paxFares.map((f, key) => (
                <div style={{ marginBottom: "5px" }}>
                  <StyledParagraph size="small">
                    {key === 0 ? "Departure" : "Return"}
                  </StyledParagraph>
                  <SpaceBetweenAlignContent key={key}>
                    <StyledParagraph style={{ fontSize: "14px" }}>
                      Passenger &nbsp;x&nbsp; {numberOfAdults}
                    </StyledParagraph>

                    <StyledTitle level={5} style={{ color: "#434455" }}>
                      {formatNumberAsCurrency(
                        f.TotalFare * numberOfAdults || 0,
                        selectedBus[0]?.Currency
                      )}
                    </StyledTitle>
                  </SpaceBetweenAlignContent>
                </div>
              ))
            : paxFares.map((f, key) => (
                <SpaceBetweenAlignContent key={key}>
                  <StyledParagraph style={{ fontSize: "14px" }}>
                    Passenger &nbsp;x&nbsp; {numberOfAdults}
                  </StyledParagraph>

                  <StyledTitle level={5} style={{ color: "#434455" }}>
                    {formatNumberAsCurrency(
                      f.TotalFare * numberOfAdults || 0,
                      selectedBus[0]?.Currency
                    )}
                  </StyledTitle>
                </SpaceBetweenAlignContent>
              ))}
        </BreakdownWrapper>
      )}

      <SpaceBetweenAlignContent>
        {confirmData?.length && confirmData[0]?.IsDiscounted ? (
          <p className="total-passengers-text">Total for all passengers</p>
        ) : (
          <StyledParagraph size="default">
            Total for all passengers
          </StyledParagraph>
        )}

        <div className="make-payment-amount-wrapper">
          {confirmData?.length && confirmData[0]?.IsDiscounted ? (
            <StrikeThroughAmount>
              {formatNumberAsCurrency(
                bookingAmount + discountAmount,
                selectedBus[0]?.Currency
              )}
            </StrikeThroughAmount>
          ) : null}
          <StyledTitle level={3}>
            {formatNumberAsCurrency(
              bookingAmount || 0,
              selectedBus[0]?.Currency
            )}
          </StyledTitle>
        </div>
      </SpaceBetweenAlignContent>
      {confirmData?.length && confirmData[0]?.IsDiscounted ? (
        <div className="discount-container-desktop">
          <span>{t(translations).discountApplied}</span>
          <span className="discount-code-text">
            {confirmData[0]?.PassengerDetails?.PromoCode}
          </span>
          <span className="discount-amount-off-text">
            ({formatNumberAsCurrency(discountAmount, selectedBus[0]?.Currency)}{" "}
            {t(translations).off})
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default RoadFareBreakdown;
